import { translations } from "@/lib/translations";

export const TEXT_GROUPS = {
  nav: "Menü", hero: "Startseite: Titelbild & Suche", usps: "Startseite: Kacheln", islands: "Inseln (Namen & Startseiten-Abschnitt)", featured: "Startseite: Empfehlungen",
  lastMinute: "Last-Minute", newSection: "Startseite: Neu bei uns", places: "Startseite: Beliebte Orte", tips: "Startseite: Reisetipps", faqSection: "Startseite: Häufige Fragen", recent: "Zuletzt angesehen", similar: "Ähnliche Objekte", reviews: "Bewertungen", newsletter: "Newsletter", island: "Insel- & Ortsseiten",
  complex: "Anlagen / Fincas", property: "Objektseite", prices: "Preise", filters: "Suche & Filter", booking: "Buchung & Anfrage", wishlist: "Merkliste",
  priceAlert: "Preisalarm", contact: "Kontaktseite", legal: "Rechtliches & Cookie-Hinweis", footer: "Footer", gallery: "Bildergalerie (Bildunterschriften)", extras: "Zuschläge & Extras",
};
const SKIP = new Set(["admin"]);

const flatten = (obj, prefix = "", out = []) => {
  Object.entries(obj || {}).forEach(([k, v]) => {
    const p = prefix ? `${prefix}.${k}` : k;
    if (typeof v === "string") out.push(p);
    else if (v && typeof v === "object") flatten(v, p, out);
  });
  return out;
};
export const TEXT_PATHS = flatten(translations.de).filter((p) => !SKIP.has(p.split(".")[0]));
export const groupOf = (path) => path.split(".")[0];
export const groupLabel = (g) => TEXT_GROUPS[g] || g;

export const getPath = (obj, path) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);
const setPath = (obj, path, value) => {
  const keys = path.split(".");
  let cur = obj;
  for (let i = 0; i < keys.length - 1; i++) { if (cur[keys[i]] == null || typeof cur[keys[i]] !== "object") return; cur = cur[keys[i]]; }
  cur[keys[keys.length - 1]] = value;
};
export const defaultText = (path, lang) => getPath(translations[lang] || translations.de, path) ?? getPath(translations.de, path) ?? "";

/** Eingebaute Texte mit Admin-Überschreibungen (settings.ui_texts {pfad: {de, en, …}}) zusammenführen. */
export const applyTextOverrides = (base, ui, lang) => {
  const entries = Object.entries(ui || {}).filter(([, v]) => typeof v?.[lang] === "string" && v[lang].trim());
  if (!entries.length) return base;
  const out = JSON.parse(JSON.stringify(base));
  entries.forEach(([path, v]) => setPath(out, path, v[lang]));
  return out;
};

export const HOME_TEXT_PATHS = ["islands.subtitle", "islands.title", "offers.subtitle", "offers.title", "featured.subtitle", "featured.title", "newSection.subtitle", "newSection.title", "newSection.all", "lastMinute.subtitle", "lastMinute.title", "places.subtitle", "places.title", "places.link", "reviews.subtitle", "reviews.title", "tips.subtitle", "tips.title", "tips.read", "faqSection.subtitle", "faqSection.title", "recent.subtitle", "recent.title", "hero.badge", "hero.subtitle"];
